import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-leave-confirmation-modal',
  templateUrl: './leave-confirmation-modal.component.html',
  styleUrls: ['./leave-confirmation-modal.component.css']
})
export class LeaveConfirmationModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<LeaveConfirmationModalComponent>) { }

  ngOnInit(): void {

  }

  clickClose() {
    this.matDialogRef.close();
  }

  clickConfirm() {
    this.matDialogRef.close({ leave: true });
  }
}